import React from "react";
import { Helmet } from "react-helmet-async";
import { IPageAboutUs } from "Interfaces/interface.informationalPages";
import SectionOurCulture from "./SectionOurCulture";
import SectionOurJourney from "./SectionOurJourney";
import SectionOurTeam from "./SectionOurTeam";
import SectionOurMission from "./SectionOurMission";
import SectionAboutUsHero from "./SectionAboutUsHero";
import OurExperties from "./OurExperties";
import SectionOurVision from "./OurVisionSection";

const PageAbout: React.FC<IPageAboutUs> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>About || 360CUSTOMIZER</title>
      </Helmet>

      <div className="container">
        <SectionAboutUsHero />
        <SectionOurMission />
        <SectionOurVision />
        <OurExperties />
        <SectionOurTeam />
        <SectionOurJourney />
        <SectionOurCulture />
      </div>
    </div>
  );
};

export default PageAbout;
